import { useEffect, useState, useMemo } from 'react'
import styles from './index.less'
import { useRouteProps } from 'umi'
import { useStore } from '@/states/store'
import openPayDialog from '@/components/PayDialog'

export default () => {
  const router = useRouteProps()
  const baseStore = useStore()

  return (
    router?.meta?.showBanner &&
    baseStore.isLogin && (
      <div
        className={styles.banner}
        onClick={() => {
          openPayDialog({ pageInfo: 'banner' })
        }}
      >
        <img src={'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/hengfuneirongtu2@2x.png'} alt="" />
      </div>
    )
  )
}
